'use client';
import React, { useState } from 'react';
import Button from '../ui/button';
import Image from 'next/image';
import InputComponent from '@/app/[countryCode]/(auth)/sign-in/_components/InputComponent';
import { useForm } from 'react-hook-form';
import { addContactToActiveCampaign } from '@/actions/addContactToActiveCampaign';
import { toast } from 'sonner';

const SignUpModule = () => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const [error, setError] = useState<{ message: string } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      const result = await addContactToActiveCampaign({
        email: data.email,
        firstName: '-',
        lastName: '-',
      });
      if (result) {
        toast.success('Success! You have been subscribed.');
        reset();
      } else {
        toast.error('Failed to subscribe to the newsletter! Try again.');
      }
    } catch (error) {
      toast.error('Failed to subscribe to the newsletter! Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 rounded-[10px] bg-off-white my-4 p-6 ">
      <div className="w-2/3 mx-auto flex items-center justify-center flex-col">
        <Image
          src={`/assets/newsletter.webp`}
          alt=""
          width={200}
          height={200}
          className="mx-auto"
        />
        <h2 className="font-bold text-xl text-center">
          Download the Ultimate Welding Guide
        </h2>
      </div>
      <p className="text-[16px] font-proxima_font">
        Sign up to our newsletter now for a free copy of our Ultimate Welding
        Guide book. Inside you'll find full guides on MIG, TIG and Stick
        welding, PLUS plasma cutting. It also includes detailed settings for TIG
        and Stick machines, so you won't have to waste time mucking around
        trying to find the right amps, you can just go with our tried and tested
        settings.
      </p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-3 relative"
      >
        {/* First Name */}
        {/* <InputComponent
          name="firstName"
          label="First Name"
          errors={errors}
          register={register}
          rules={{
            required: 'First Name is a required field.',
          }}
          setValue={setValue}
        /> */}

        {/* Last Name */}
        {/* <InputComponent
          name="lastName"
          label="Last Name"
          errors={errors}
          register={register}
          rules={{
            required: 'Last Name is a required field.',
          }}
          setValue={setValue}
        /> */}

        {/* Email */}
        <InputComponent
          name="email"
          label="Email Address"
          type="email"
          errors={errors}
          register={register}
          rules={{
            required: 'Invalid email address',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address',
            },
          }}
          setValue={setValue}
          submitError={error && error.message}
          setSubmitError={setError}
        />

        <Button
          label="Submit"
          variant="outline"
          className="w-full select-none leading-unset whitespace-nowrap md:px-10"
          disabled={isLoading}
        />
      </form>
    </div>
  );
};

export default SignUpModule;
